<template>
  <v-container class="container-card">
    <v-card>
      <ListaColabEmpresa />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import ListaColabEmpresa from "@/components/colaborador/colabEmpresa/ListaColabEmpresa";

export default {
  name: "ConsultaColabEmpresa",

  components: {
    ListaColabEmpresa
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Colaborador Empresa");
  }
};
</script>

<style scoped>
.v-tab--active {
  background-color: white;
}
</style>
